import {htmlEscape} from 'escape-goat';
import {fomanticQuery} from '../modules/fomantic/base.ts';
import {hideElem, querySingleVisibleElem, showElem, toggleElem} from '../utils/dom.ts';

const {appSubUrl} = window.config;

export function initRepoTemplateSearch() {
  const elRepoTemplate = document.querySelector<HTMLInputElement>('#repo_template');
  if (!elRepoTemplate) return; // make sure the current page is "new repo" page

  const checkTemplate = function () {
    const elTemplateUnits = document.querySelector('#template_units');
    const elNonTemplate = document.querySelector('#non_template');
    const ecadToolsField = document.querySelector('#ecadtools-field');
    const createDevelop = document.querySelector('#create-develop-branch-container');
    const defaultBranch = document.querySelector<HTMLInputElement>('input[name="default_branch"]');
    const defaultBranchContainer = document.querySelector<HTMLElement>('#default-branch-container');
    const protectDefaultBranchContainer = document.querySelector<HTMLElement>('#protect-default-branch-container');

    const hasSelectedTemplate = elRepoTemplate.value !== '' && elRepoTemplate.value !== '0';
    if (hasSelectedTemplate) {
      showElem(elTemplateUnits);
      hideElem(elNonTemplate);
      if (defaultBranch) defaultBranch.disabled = true;

      if (protectDefaultBranchContainer) {
        elTemplateUnits?.append(protectDefaultBranchContainer);
      }
      if (createDevelop) {
        // special-case adding the "create a develop branch" field after the other template-specific fields
        elTemplateUnits?.append(createDevelop);
        // Make sure it's visible if the Advanced section was collapsed.
        createDevelop.classList.remove('hidden', 'transition');
      }

      if (ecadToolsField) hideElem(ecadToolsField);
    } else {
      hideElem(elTemplateUnits);
      showElem(elNonTemplate);
      if (defaultBranch) defaultBranch.disabled = false;

      if (protectDefaultBranchContainer) {
        defaultBranchContainer?.insertAdjacentElement('afterend', protectDefaultBranchContainer);
      }

      if (createDevelop) {
        const autoInitContainer = document.querySelector('#auto-init-container');
        autoInitContainer?.insertAdjacentElement('afterend', createDevelop);
      }

      if (ecadToolsField) showElem(ecadToolsField);
    }
  };
  elRepoTemplate.addEventListener('change', checkTemplate);
  checkTemplate();

  const elUid = document.querySelector<HTMLInputElement>('#uid');
  const elForm = elUid.closest('form');
  const elCreateRepoErrorMessage = elForm.querySelector('#create-repo-error-message');
  const elRepoTemplateDropdown = document.querySelector<HTMLElement>('#repo_template_search');

  const $dropdown = fomanticQuery(elRepoTemplateDropdown);
  const changeOwner = function () {
    const elSubmitButton = querySingleVisibleElem<HTMLInputElement>(elForm, '.ui.primary.button');
    const elOwnerItem = document.querySelector(`.ui.selection.owner.dropdown .menu > .item[data-value="${CSS.escape(elUid.value)}"]`);
    if (elCreateRepoErrorMessage) {
      hideElem(elCreateRepoErrorMessage);
      elSubmitButton.disabled = false;
      if (elOwnerItem) {
        elCreateRepoErrorMessage.textContent = elOwnerItem.getAttribute('data-create-repo-disallowed-prompt') ?? '';
        const hasError = Boolean(elCreateRepoErrorMessage.textContent);
        toggleElem(elCreateRepoErrorMessage, hasError);
        elSubmitButton.disabled = hasError;
      }
    }

    $dropdown.dropdown('setting', {
      apiSettings: {
        url: `${appSubUrl}/repo/search?q={query}&template=true&priority_owner_id=${elUid.value}`,
        onResponse(response: {data: Array<{repository: {full_name: string, id: number}}>}) {
          const results = [];
          results.push({name: '', value: ''}); // empty item means not using template
          for (const tmplRepo of response.data) {
            results.push({
              name: htmlEscape(tmplRepo.repository.full_name),
              value: String(tmplRepo.repository.id),
            });
          }
          $dropdown.fomanticExt.onResponseKeepSelectedItem($dropdown, elRepoTemplate.value);
          return {results};
        },
        cache: false,
      },
    });
  };
  elUid.addEventListener('change', changeOwner);
  changeOwner();
}
